var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebuianduxn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-26,.cls-28{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-23,.cls-27,.cls-29,.cls-4{fill:#2f2143;}.cls-19,.cls-22,.cls-24,.cls-5{fill:#fff;}.cls-6{fill:#9ca1a4;}.cls-7{fill:#2e3133;}.cls-8{fill:#fdc437;}.cls-9{fill:#9a499c;}.cls-10{fill:#b0adad;}.cls-11{fill:#59add1;}.cls-12{fill:#231f20;}.cls-13{mix-blend-mode:darken;}.cls-14{clip-path:url(#clip-path);}.cls-15{clip-path:url(#clip-path-2);}.cls-16{clip-path:url(#clip-path-3);}.cls-17{fill:#82d4f6;}.cls-18{fill:#cbe6ef;}.cls-19{font-size:15.14px;}.cls-19,.cls-22,.cls-23,.cls-24{font-family:Arial-BoldMT, Arial;}.cls-19,.cls-22,.cls-23,.cls-24,.cls-29{font-weight:700;}.cls-20{letter-spacing:-0.07em;}.cls-21{letter-spacing:-0.04em;}.cls-22{font-size:20.08px;}.cls-23{font-size:25px;}.cls-24{font-size:20px;}.cls-25{fill:#2e1f42;}.cls-26{stroke:#2e1f42;stroke-width:1.54px;}.cls-26,.cls-27,.cls-28{stroke-miterlimit:10;}.cls-27,.cls-28{stroke:#231f20;stroke-width:1.69px;}.cls-29{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 218.65,
    y: 219.02,
    width: 66.06,
    height: 1.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.14,
    y: 219.16,
    width: 61.62,
    height: 1.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.47,
    y: 219.16,
    width: 56.9,
    height: 1.06
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WEB &amp;amp;UI AND UX N") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M477.71,235.47H170.09V61.94a16.06,16.06,0,0,1,16.06-16.06h275.5a16.06,16.06,0,0,1,16.06,16.06Z",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 181.29,
    y: 57.15,
    width: 285.22,
    height: 172.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.06,260.47H183.73a13.64,13.64,0,0,1-13.64-13.64V235.47H477.71v11.36a13.65,13.65,0,0,1-13.65,13.64",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 299.6,
    y: 260.54,
    width: 56.82,
    height: 21.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 286.86,
    y: 281.78,
    width: 80.19,
    height: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M328,248a4.12,4.12,0,1,1-4.12-4.12A4.12,4.12,0,0,1,328,248",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 218.65,
    y: 128.37,
    width: 66.88,
    height: 60.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 295.76,
    y: 128.51,
    width: 62.39,
    height: 60.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 370.76,
    y: 128.51,
    width: 57.61,
    height: 60.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181.29,
    y: 57.15,
    width: 285.22,
    height: 17.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M430.13,68.49H237.27a2.74,2.74,0,0,1,0-5.48H430.13a2.74,2.74,0,1,1,0,5.48",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 435.53,
    y: 63.07,
    width: 12.75,
    height: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 450.62,
    y: 63.07,
    width: 12.75,
    height: 5.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M193,65.75A2.74,2.74,0,1,1,190.29,63,2.74,2.74,0,0,1,193,65.75",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.29,65.75A2.74,2.74,0,1,1,200.55,63a2.74,2.74,0,0,1,2.74,2.74",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.54,65.75A2.74,2.74,0,1,1,210.8,63a2.74,2.74,0,0,1,2.74,2.74",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.8,65.75A2.74,2.74,0,1,1,221.06,63a2.74,2.74,0,0,1,2.74,2.74",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 199.24,
    y: 74.48,
    width: 236.29,
    height: 17.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 435.53,
    y: 74.48,
    width: 30.98,
    height: 154.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 181.29,
    y: 74.48,
    width: 30.98,
    height: 154.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 212.27,
    y: 92,
    width: 223.26,
    height: 25.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.64,
    y: 98.11,
    width: 53.94,
    height: 14.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 285.53,
    y: 107.89,
    width: 21.31,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 316,
    y: 107.89,
    width: 21.31,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 346.47,
    y: 107.89,
    width: 21.31,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 376.93,
    y: 107.89,
    width: 21.31,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 407.4,
    y: 107.89,
    width: 21.31,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 195.39,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 198.77,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 202.16,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 205.54,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 208.93,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 212.31,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 215.7,
    width: 66.06,
    height: 1.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 218.65,
    y: 219.09,
    width: 66.06,
    height: 1.06
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 195.53,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 198.92,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 202.3,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 205.69,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 209.07,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 212.46,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 215.85,
    width: 61.62,
    height: 1.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.14,
    y: 219.23,
    width: 61.62,
    height: 1.06
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 195.53,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 198.92,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 202.3,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 205.69,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 209.07,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 212.46,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 215.85,
    width: 56.9,
    height: 1.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 371.47,
    y: 219.23,
    width: 56.9,
    height: 1.06
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M536.42,65.56l-11.28,1.09a29.6,29.6,0,0,0-57.42.72c-9.63-2-18.71.95-23.1,7.49A20.11,20.11,0,0,0,441.9,85a19.46,19.46,0,0,0,19.4,19.4h75.12a19.41,19.41,0,1,0,0-38.81",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M566.45,61.6l-9.24.89a24.24,24.24,0,0,0-47,.59c-7.88-1.67-15.32.78-18.91,6.13a16.46,16.46,0,0,0-2.23,8.28,15.93,15.93,0,0,0,15.88,15.88h61.51a15.89,15.89,0,0,0,0-31.77",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M797.08,40.7H696.29a8.09,8.09,0,0,0-8.1,8.09v7.59a8.1,8.1,0,0,0,8.1,8.1h78.92s10.47,3.65,10.47,14.35c0,0,7.77-8.8,8.61-14.35h2.79a8.1,8.1,0,0,0,8.1-8.1V48.79A8.1,8.1,0,0,0,797.08,40.7Z",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1318.67,83.65h-97.13c-4.31,0-7.8,4.6-7.8,10.27v9.61c0,5.67,3.49,10.27,7.8,10.27h76.06s10.09,4.63,10.09,18.2c0,0,7.49-11.16,8.29-18.2h2.69c4.31,0,7.81-4.6,7.81-10.27V93.92C1326.48,88.25,1323,83.65,1318.67,83.65Z",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M861.62,294.3h-90.7c-4,0-7.29-4.19-7.29-9.37v-8.77c0-5.18,3.27-9.37,7.29-9.37h67s13.76-8.69,13.76-21.07c0,0,6.64,14.64,7.39,21.07h2.51c4,0,7.29,4.19,7.29,9.37v8.77C868.91,290.11,865.65,294.3,861.62,294.3Z",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(696.05 58.16)"
  }, "J", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 8.42,
    y: 0
  }, "AV"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 27.21,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.58,
    y: 0,
    xmlSpace: "preserve"
  }, " SCRIPT")), /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(777.05 288.04)"
  }, "React JS"), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1551,55.14h0a23.4,23.4,0,0,0-.25-7.29h0l3.29-4.53-2.28-5-5.58-.52,0,0a23.63,23.63,0,0,0-5.33-5h0l-.88-5.53-5.19-2-4.31,3.58V29a23.4,23.4,0,0,0-7.29.24v0l-4.53-3.29-5,2.28-.52,5.58,0,0a23.33,23.33,0,0,0-5,5.32h0l-5.53.87-2,5.19,3.57,4.31h0a23.4,23.4,0,0,0,.25,7.29h0l-3.29,4.53,2.29,5.05,5.57.52,0,0a23.22,23.22,0,0,0,5.33,5h0l.88,5.53,5.18,2,4.31-3.57v0a23.33,23.33,0,0,0,7.28-.26v0l4.53,3.29,5.05-2.28.52-5.58,0,0a23.22,23.22,0,0,0,5-5.33v0l5.53-.88,2-5.18Zm-5.7,3.86a18.92,18.92,0,1,1-11-24.4,18.92,18.92,0,0,1,11,24.4",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.4,276.7h0a16.48,16.48,0,0,0-.17-5.11h0l2.31-3.18-1.6-3.55-3.91-.36,0,0a16.41,16.41,0,0,0-3.74-3.5h0l-.61-3.88L134,255.78l-3,2.51v0a16.24,16.24,0,0,0-5.12.18v0l-3.18-2.31-3.54,1.6-.37,3.92h0a16.58,16.58,0,0,0-3.49,3.74h0l-3.88.62-1.38,3.64,2.51,3h0a16.19,16.19,0,0,0,.17,5.11h0L110.44,281l1.61,3.54,3.91.37,0,0a16.37,16.37,0,0,0,3.74,3.49h0l.61,3.88,3.64,1.38,3-2.51v0a16.55,16.55,0,0,0,5.12-.18v0l3.18,2.31,3.55-1.61.36-3.91,0,0a16.59,16.59,0,0,0,3.49-3.74v0l3.88-.62,1.37-3.64Zm-4,2.71a13.28,13.28,0,1,1-7.71-17.12,13.28,13.28,0,0,1,7.71,17.12",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M608.38,286h0a12,12,0,0,0-.13-3.78h0l1.71-2.35-1.19-2.63-2.9-.27v0a12.17,12.17,0,0,0-2.77-2.58h0l-.46-2.87-2.69-1-2.24,1.86v0a12,12,0,0,0-3.78.13h0l-2.36-1.71L588.94,272l-.27,2.89,0,0a12.38,12.38,0,0,0-2.59,2.76h0l-2.88.46-1,2.7,1.86,2.23h0a12,12,0,0,0,.13,3.79h0l-1.71,2.35,1.18,2.62,2.9.27v0a12.41,12.41,0,0,0,2.77,2.59h0l.46,2.87,2.69,1,2.24-1.86v0a12,12,0,0,0,3.78-.13v0l2.36,1.71,2.62-1.19.27-2.9h0a12.22,12.22,0,0,0,2.59-2.77h0l2.88-.46,1-2.69Zm-3,2a9.83,9.83,0,1,1-5.71-12.68A9.83,9.83,0,0,1,605.41,288",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(1353.87 289.52)"
  }, "&lt;html&gt;"), /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(1231.78 105.08)"
  }, "&lt;HTML&gt;"), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1502.25,175.36a7.94,7.94,0,1,1-11,2,7.94,7.94,0,0,1,11-2",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1543.17,170.26a7.93,7.93,0,1,1-11,2,7.93,7.93,0,0,1,11-2",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1505.78,139.56a7.93,7.93,0,1,1-11-2.05,7.93,7.93,0,0,1,11,2.05",
    transform: "translate(0 0.07)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1498.11,
    y1: 174.03,
    x2: 1499.1,
    y2: 151.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 1498.11,
    y1: 174.03,
    x2: 1499.1,
    y2: 151.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1505.33,
    y1: 184.18,
    x2: 1531.8,
    y2: 178.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 1505.33,
    y1: 184.18,
    x2: 1531.8,
    y2: 178.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 482.13,
    y1: 273.69,
    x2: 504.13,
    y2: 252.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 474.34,
    y1: 286.94,
    x2: 495.82,
    y2: 265.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 479.36,
    y1: 286.06,
    x2: 520.05,
    y2: 245.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 465.62,
    y1: 304.18,
    x2: 506.31,
    y2: 263.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 488.54,
    y1: 286.16,
    x2: 529.23,
    y2: 245.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 480.86,
    y1: 298.36,
    x2: 521.55,
    y2: 257.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 496.97,
    y1: 287.31,
    x2: 520.47,
    y2: 263.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 487.96,
    y1: 300.78,
    x2: 511.45,
    y2: 277.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 501.95,
    y1: 291.36,
    x2: 510.68,
    y2: 282.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 477.24,
    y1: 274.44,
    x2: 485.97,
    y2: 265.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 611.01,
    y1: 88.49,
    x2: 661.84,
    y2: 37.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 1203.66,
    y1: 295.77,
    x2: 1254.49,
    y2: 244.94
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-29",
    transform: "translate(770.84 142.82)"
  }, "WEB &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -211.38,
    y: 75
  }, "APP DEVELOPMENT"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebuianduxn);
export default __webpack_public_path__ + "static/media/WEB &UI AND UX N.e182c5179439eff17ad062b6e4d4176d.svg";
export { ForwardRef as ReactComponent };